/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import styles from '../../assets/styles/Emergency.module.css';

const Emergency = () => (
  <table className={styles.tablaEmergencias}>
    <tr>
      <th>Institución</th>
      <th>Dirección</th>
      <th>Teléfono</th>
    </tr>
    <tr>
      <td>Ambulancias Samu</td>
      <td />
      <td><a href='tel:131'>131</a></td>
    </tr>
    <tr>
      <td>Bomberos </td>
      <td />
      <td><a href='tel:132'>132</a></td>
    </tr>
    <tr>
      <td>Carabineros </td>
      <td />
      <td><a href='tel:133'>133</a></td>
    </tr>
    <tr>
      <td>Emergencias Municipales (Alcaldesa)</td>
      <td><a href='https://goo.gl/maps/KnjfYVuZQmoSG29k6'>PEDRO FÉLIX VICUÑA N° 199</a></td>
      <td><a href='tel:+56954179346'>9 54179346</a></td>
    </tr>
    <tr>
      <td>Tenencia Nogales</td>
      <td><a href='https://goo.gl/maps/UkLiPTbwn8yEk3z18'>PEDRO FÉLIX VICUÑA N° 611</a></td>
      <td><a href='tel:+56332433116'>33 2 433116</a></td>
    </tr>
    <tr>
      <td>Retén El Melón</td>
      <td><a href='https://goo.gl/maps/4aXzjXan2TR8wZA36'>BERNARDO O'HIGGINS N° 24</a></td>
      <td><a href='tel:+56332433123'>33 2 433123</a></td>
    </tr>
    <tr>
      <td>Cesfam Nogales</td>
      <td><a href='https://goo.gl/maps/VJ7MGV3eY6KEJuYL9'>Manuel Aldunate</a></td>
      <td><a href='tel:+56332262944'>33 2 262944</a></td>
    </tr>
    <tr>
      <td>Cesfam El Melón</td>
      <td><a href='https://goo.gl/maps/5JuytA5FvSMvB8xg7'>Gustavo Filippi Muratto 601</a></td>
      <td><a href='tel:+56332280256'>33 2 280256</a></td>
    </tr>
    <tr>
      <td>Cecosf Ex Asentamiento El Melón</td>
      <td><a href='https://goo.gl/maps/EKjoyGv9HTMbG6du9'>Ex Asentamiento El Melón</a></td>
      <td><a href='tel:+56332281347'>33 2 281347</a></td>
    </tr>
    <tr>
      <td>Cecosf El Polígono</td>
      <td><a href='https://goo.gl/maps/YGxHxUiWT2ayZ3gr6'>Los Zorzales 10</a></td>
      <td><a href='tel:+5633 2 298434'>33 2 298434</a></td>
    </tr>
    <tr>
      <td>Cuerpo de Bomberos de Nogales</td>
      <td><a href='https://goo.gl/maps/ZycHdwE1YCs4PYLp6'>Simón Bolívar 14</a></td>
      <td><a href='tel:+5633 2 262823'>33 2 262823</a></td>
    </tr>
    <tr>
      <td>Cuerpo de Bomberos El Melón</td>
      <td><a href='https://goo.gl/maps/swKuB6UXQC6PTkQg9'>Calle Ramón Freire S/N</a></td>
      <td><a href='tel:+5633 2 281309'>33 2 281309</a></td>
    </tr>
    <tr>
      <td>Consultas por síntomas de coronavirus (COVID-19) </td>
      <td />
      <td><a href='tel:600 360 77 77'>600 360 77 77</a></td>
    </tr>
    <tr>
      <td>Policía de Investigaciones</td>
      <td />
      <td><a href='tel:134'>134</a></td>
    </tr>
    <tr>
      <td>Fono Adulto Mayor</td>
      <td />
      <td><a href='tel:800 400 035'>800 400 035</a></td>
    </tr>
    <tr>
      <td>Agua Potable El Melón</td>
      <td><a href='https://goo.gl/maps/CEyL6ewqRSP59djw5'>Calle Ramón Freire 43</a></td>
      <td><a href='tel:+56332280006'>33 2 280006</a></td>
    </tr>
    <tr>
      <td>Juzgado de Policía Local</td>
      <td><a href='https://goo.gl/maps/vqQcV5LTkhc1wCWw6'>Pedro Felix Vicuña 199, Nogales</a></td>
      <td><a href='tel:+56992329434'>9 9232 9434</a></td>
    </tr>
    <tr>
      <td>Esval</td>
      <td />
      <td><a href='tel:600 600 60 60'>600 600 60 60</a></td>
    </tr>
    <tr>
      <td>Chilquinta (Desde Telefonos Fijos)</td>
      <td />
      <td><a href='tel:600 600 50 00'>600 600 50 00</a></td>
    </tr>
    <tr>
      <td>Chilquinta (Desde Celulares)</td>
      <td />
      <td><a href='tel:+56 32 2 265300'>32 2 265300</a></td>
    </tr>
  </table>
);
export default Emergency;
